import React from 'react';
import PropTypes from 'prop-types';

import { TagsCollection } from '@models/tag';
import TagItem from './TagItem';

const TagsList = (props) => {
  const { tags, onRemove } = props;

  const tagList = tags.models.map((tag) => (
    <TagItem key={`tag-${tag.name}`} tag={tag} onRemove={onRemove} />
  ));

  return (
    <>
      {tagList}
    </>
  );
};

TagsList.propTypes = {
  tags: PropTypes.instanceOf(TagsCollection).isRequired,
  onRemove: PropTypes.func,
};

TagsList.defaultProps = {
  onRemove: null,
};

export default TagsList;
